import { BasketIcon, CalendarIcon, CheckIcon, SparkleIcon, UtensilsIcon } from '../components/Icons';

export function LandingPage() {
  return (
    <main className="landing">
      <nav className="landing-nav shell">
        <a className="brand" href="/" aria-label="龙庭备菜助手首页">
          <span className="brand__mark"><UtensilsIcon size={22} /></span>
          <span><strong>龙庭备菜助手</strong><small>LONGTING KITCHEN</small></span>
        </a>
        <span className="private-badge"><span /> 私密工作台</span>
      </nav>
      <section className="hero shell">
        <div className="hero__copy">
          <span className="hero__eyebrow"><SparkleIcon size={17} /> 让每周备菜更简单</span>
          <h1>选好菜，采购清单<br /><em>自动算清楚。</em></h1>
          <p>为厨房负责人设计的周备菜工具。按天勾选菜品，食材自动汇总，一次确认即可发给采购人员。</p>
          <div className="hero__notice"><CheckIcon size={18} /><span>本页面不提供公开登录入口，请使用管理员发送的私密链接进入。</span></div>
        </div>
        <div className="hero-card" aria-label="产品流程预览">
          <div className="hero-card__top"><span>下周备菜计划</span><small>7月27日—8月2日</small></div>
          <div className="hero-card__day">
            <span className="hero-card__date">周一<small>7月27日</small></span>
            <span className="hero-card__dish">豆干炒肉 <b>1批</b></span>
            <span className="hero-card__dish">酸菜芋儿鸡 <b>2批</b></span>
          </div>
          <div className="hero-card__summary">
            <span><BasketIcon size={18} /> 自动汇总</span>
            <div><span>豆干</span><strong>4<small>斤</small></strong></div>
            <div><span>鸡肉</span><strong>30<small>斤</small></strong></div>
            <div><span>薄皮芋儿</span><strong>14<small>斤</small></strong></div>
          </div>
        </div>
      </section>
      <section className="landing-features shell">
        <article><span><CalendarIcon /></span><h2>按周安排</h2><p>自动识别工作日、节假日和调休，只安排真正供餐的日子。</p></article>
        <article><span><UtensilsIcon /></span><h2>固定配方</h2><p>一批就是 50 人标准用量，常用配方录入一次，之后直接复用。</p></article>
        <article><span><BasketIcon /></span><h2>一次输出</h2><p>微信文案、Excel 和只读网页来自同一版数据，结果始终一致。</p></article>
      </section>
      <footer className="landing-footer shell">龙庭备菜助手 · 让厨房计划少一步手写，多一分准确</footer>
    </main>
  );
}
